import * as z from 'zod'

import { BODY_AREAS, bodyAreaOptions } from '@flows/configs/petHealthV2/conditions'
import {
  v2PetPortrait,
  v2Text,
  v2TextWithPetName,
} from '@flows/configs/petHealthV2/steps/elements/shared'
import { startConditionAction } from '@flows/configs/petHealthV2/utils'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'

const condition_area = (params: StepConfigParams) => {
  const conditionPath = params.helperFunctions.getTransientPath('condition')

  return {
    stepContent: [
      v2PetPortrait(params),
      { type: 'title', text: v2TextWithPetName(params, 'steps.condition_area.title') },
      {
        type: 'searchableList',
        shouldTrackValues: true,
        groupBy: 'alphabetical',
        searchPlaceholder: v2Text('steps.condition_area.searchPlaceholder'),
        name: `${conditionPath}.health_status_area`,
        options: bodyAreaOptions(),
      },
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [`${conditionPath}.health_status_area`]: z.enum(BODY_AREAS),
    }),
    onPrepare: {
      type: 'simpleHook',
      callback: (flowValues: FlowValues) => ({
        formValues: startConditionAction(params, flowValues),
      }),
    },
    subFlow: params.subFlow,
    nextStep: 'condition_illness',
  } as const satisfies AnyStepConfiguration
}

export default condition_area
